import * as React from 'react';
import styled from 'styled-components';
import * as ethers from 'ethers';
import crypto from 'crypto-js';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Center,Box,Button,Text,useDisclosure,Image} from '@chakra-ui/react';
import { LoadingModal } from '../modal/loadingModalComponent';

import { 
  Modal,  
  ModalOverlay,
  HStack,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { mintNFTTopShot } from '../../usecases/repositories/topShot';
import { useRecoilValue } from 'recoil';
import { requestIdState } from '../../states/requestIdState';
import { nftJsonState } from '../../states/nftJsonState';



type Props = {
  saveButtonStatus:string,
  saveDoneButtonStatus:string,
}
export const SaveBackupcardDoneButton: React.FC<Props> = (props) => {
  const nftJsonStatus = useRecoilValue(nftJsonState);
  const requestId = useRecoilValue(requestIdState);

  const { isOpen:isOpenLM, onOpen:onOpenLM, onClose:onCloseLM } = useDisclosure();
  const { isOpen:isOpenM, onOpen:onOpenM, onClose:onCloseM } = useDisclosure();

  const [t, i18n] = useTranslation();
  const nav = useNavigate();


  return (
    <>
      <Button
        onClick={onOpenM}
        borderRadius={'10px'}       
        backgroundColor={'orange.300'}
        colorScheme={'orange.300'}
        id={`btn-default-backup-go`}
        w={'140px'}
      >
       {t('進む')}
      </Button>

      {/* ローディング用モーダル */}
      <LoadingModal 
        isOpen={isOpenLM} 
        onClose={onCloseLM} 
      />

      {/* アラート用モーダル */}
      <Modal isCentered isOpen={isOpenM} onClose={onCloseM}>
        <ModalOverlay
            backdropFilter='blur(15px)'
        />
        <ModalContent
          bg={`tomato`}
          w={`94%`}
        >
          <ModalHeader>
            <HStack>
              <WarningTwoIcon
                boxSize={7}
                color={`yellow`}
              /> 
              <Text
                color={`white`}
              >
                {t('注意')}
              </Text>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text 
              color={`white`}
              fontWeight={`bold`}
            >{t('バックアップカードを必ず保存してください。')}<br/>{t('保存しない場合、NFTを復元できません。')}
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button 
              onClick={onCloseM} 
              mr={`8px`}
              id={`btn-default-backupmodal-back`}
            >{t('戻る')}</Button>



            <Button 
              onClick={async()=>{ 
                onOpenLM();
                const result = await mintNFTTopShot(
                  new ethers.Wallet(localStorage.getItem('privateKey')).address,
                  `browserWallet`,
                  requestId,
                  nftJsonStatus.nftmeta
                );
                if (result === `6`) {
                  nav(`/${result}`,{state:{useWalletAddress:`${new ethers.Wallet(localStorage.getItem('privateKey')).address}`}});
                }else{
                  nav(`/${result}`);
                }
                onCloseLM();
              }}
              id={`btn-default-backupmodal-go`}
            >{t('進む')}</Button>
            
          </ModalFooter>
        </ModalContent>
      </Modal>  
    </>
  );
};